<template>
  <div class="receive-records-page">
    <div class="container">
      <div class="page-header">
        <h1 class="page-title">{{ $t('receiveRecords.title') }}</h1>
        <p class="page-subtitle">{{ $t('receiveRecords.subtitle') }}</p>
        <div class="retention-notice">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 8V12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 16H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>{{ $t('receiveRecords.retentionNotice') }}</span>
        </div>
      </div>

      <div class="record-type-tabs" role="tablist" :aria-label="$t('receiveRecords.recordsTitle')">
        <button
          class="record-type-tab"
          :class="{ active: activeTab === 'phone' }"
          type="button"
          role="tab"
          :aria-selected="activeTab === 'phone'"
          @click="changeRecordType('phone')"
        >
          {{ $t('receiveRecords.phoneTab') }}
        </button>
        <button
          class="record-type-tab"
          :class="{ active: activeTab === 'mail' }"
          type="button"
          role="tab"
          :aria-selected="activeTab === 'mail'"
          @click="changeRecordType('mail')"
        >
          {{ $t('receiveRecords.mailTab') }}
        </button>
      </div>
      
      <!-- 筛选和搜索 -->
      <div v-if="activeTab === 'phone'" class="filters-section">
        <div class="card">
          <div class="filters-content">
            <div class="filter-group">
              <label class="filter-label">{{ $t('receiveRecords.channelCodeFilter') }}</label>
              <input 
                type="text" 
                v-model="filters.channelCode" 
:placeholder="$t('receiveRecords.channelCodePlaceholder')"
                class="filter-input"
              />
            </div>
            
            <div class="filter-actions">
              <button class="btn btn-primary" @click="applyFilters" :disabled="loading">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 21L16.514 16.506" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
{{ $t('common.search') }}
              </button>
              <button class="btn btn-outline" @click="resetFilters">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 4V10H7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M3.51001 15C4.01716 16.4332 4.87906 17.7161 6.01543 18.727C7.15181 19.7378 8.52549 20.4432 10.0083 20.7808C11.4911 21.1185 13.0348 21.0781 14.4952 20.6632C15.9556 20.2483 17.2853 19.4732 18.36 18.41" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M23 20V14H17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M20.49 9C19.9828 7.56678 19.1209 6.28392 17.9845 5.27304C16.8482 4.26216 15.4745 3.55685 13.9917 3.21916C12.5089 2.88146 10.9652 2.92188 9.50481 3.33681C8.04439 3.75174 6.71475 4.52677 5.64 5.59" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
{{ $t('common.reset') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 记录列表 -->
      <div class="records-section">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">
              {{ activeTab === 'phone' ? $t('receiveRecords.phoneRecordsTitle') : $t('receiveRecords.mailRecordsTitle') }}
            </h3>
            <div class="header-actions">
              <button v-if="activeTab === 'phone'" class="btn btn-success" @click="handleExport" :disabled="loading || exporting">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 15V3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                {{ exporting ? $t('receiveRecords.exporting') : $t('receiveRecords.exportExcel') }}
              </button>
              <button class="btn btn-secondary" @click="refreshRecords" :disabled="loading">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 4V10H7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M3.51001 15C4.01716 16.4332 4.87906 17.7161 6.01543 18.727C7.15181 19.7378 8.52549 20.4432 10.0083 20.7808C11.4911 21.1185 13.0348 21.0781 14.4952 20.6632C15.9556 20.2483 17.2853 19.4732 18.36 18.41" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M23 20V14H17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M20.49 9C19.9828 7.56678 19.1209 6.28392 17.9845 5.27304C16.8482 4.26216 15.4745 3.55685 13.9917 3.21916C12.5089 2.88146 10.9652 2.92188 9.50481 3.33681C8.04439 3.75174 6.71475 4.52677 5.64 5.59" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
{{ $t('common.refresh') }}
              </button>
            </div>
          </div>
          
          <template v-if="!loading && records.length > 0">
          <div v-if="activeTab === 'phone'" class="records-table">
            <div class="table-header">
              <div class="table-cell">{{ $t('receiveRecords.headers.channelCode') }}</div>
              <div class="table-cell">{{ $t('receiveRecords.headers.actualAmount') }}</div>
              <div class="table-cell">{{ $t('receiveRecords.headers.originalAmount') }}</div>
              <div class="table-cell">{{ $t('receiveRecords.headers.discountAmount') }}</div>
              <div class="table-cell">{{ $t('receiveRecords.headers.activity') }}</div>
              <div class="table-cell">{{ $t('receiveRecords.headers.phoneNumber') }}</div>
              <div class="table-cell">{{ $t('receiveRecords.headers.verificationCode') }}</div>
              <div class="table-cell">{{ $t('receiveRecords.headers.smsContent') }}</div>
              <div class="table-cell">{{ $t('receiveRecords.headers.time') }}</div>
            </div>
            
            <div v-for="record in records" :key="record.id" class="table-row">
              <div class="table-cell">
                <span class="channel-code">{{ record.code }}</span>
              </div>
              <div class="table-cell">
                <span class="price">{{ getActualAmount(record) }}</span>
              </div>
              <div class="table-cell">
                <span :class="hasActivity(record) ? 'original-price' : 'price-muted'">{{ getOriginalAmount(record) }}</span>
              </div>
              <div class="table-cell">
                <span v-if="hasActivity(record)" class="discount-badge">{{ getDiscountAmount(record) }}</span>
                <span v-else class="price-muted">--</span>
              </div>
              <div class="table-cell">
                <span v-if="hasActivity(record)" class="activity-name">{{ getActivityName(record) }}</span>
                <span v-else class="price-muted">--</span>
              </div>
              <div class="table-cell">
                <span class="phone-number" @click="copyText(record.phoneNo)">{{ record.phoneNo }}</span>
              </div>
              <div class="table-cell">
                <div v-if="record.smsCode" class="verification-code">
                  <span class="code-value" @click="copyText(record.smsCode)">
                    {{ record.smsCode }}
                  </span>
                  <button class="copy-btn" @click="copyText(record.smsCode)" :title="$t('receiveRecords.copyVerificationCode')">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M15 2H9C8.44772 2 8 2.44772 8 3V5C8 5.55228 8.44772 6 9 6H15C15.5523 6 16 5.55228 16 5V3C16 2.44772 15.5523 2 15 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
                <span v-else class="no-code">-</span>
              </div>
              <div class="table-cell">
                <div class="message-content" :title="record.content" @click="copyText(record.content)">
                  {{ truncateText(record.content, 50) }}
                </div>
              </div>
              <div class="table-cell">
                <div class="time-info">
                  <div class="date">{{ formatDateTime(record.createTime) }}</div>
                </div>
              </div>
            </div>
          </div>

          <div v-else class="records-table mail-records-table">
            <div class="table-header">
              <div class="table-cell">{{ $t('receiveRecords.mailHeaders.project') }}</div>
              <div class="table-cell">{{ $t('receiveRecords.mailHeaders.email') }}</div>
              <div class="table-cell">{{ $t('receiveRecords.mailHeaders.verificationCode') }}</div>
              <div class="table-cell">{{ $t('receiveRecords.mailHeaders.amount') }}</div>
              <div class="table-cell">{{ $t('receiveRecords.mailHeaders.status') }}</div>
              <div class="table-cell">{{ $t('receiveRecords.mailHeaders.receivedTime') }}</div>
            </div>

            <div v-for="record in records" :key="record.activationId" class="table-row">
              <div class="table-cell"><span class="channel-code">{{ record.projectName || record.serviceCode }}</span></div>
              <div class="table-cell"><span class="phone-number" @click="copyText(record.mailAddress)">{{ record.mailAddress }}</span></div>
              <div class="table-cell">
                <div class="verification-code">
                  <span class="code-value" @click="copyText(record.verificationCode)">{{ record.verificationCode }}</span>
                  <button class="copy-btn" @click="copyText(record.verificationCode)" :title="$t('receiveRecords.copyVerificationCode')">
                    {{ $t('common.copy') }}
                  </button>
                </div>
              </div>
              <div class="table-cell"><span class="price">{{ record.userPrice }}</span></div>
              <div class="table-cell"><span class="channel-code">{{ record.status }}</span></div>
              <div class="table-cell"><span class="time-info date">{{ formatDateTime(record.receivedTime || record.createTime) }}</span></div>
            </div>
          </div>
          </template>
          
          <div v-else-if="loading" class="loading-state">
            <div class="spinner"></div>
            <p>{{ $t('receiveRecords.loadingRecords') }}</p>
          </div>
          
          <div v-else class="empty-state">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12L11 14L15 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p>{{ activeTab === 'phone' ? $t('receiveRecords.noRecords') : $t('receiveRecords.noMailRecords') }}</p>
          </div>
          
          <!-- 分页 -->
          <div class="pagination" v-if="!loading && records.length > 0">
            <button 
              class="page-btn" 
              :disabled="pagination.currentPage <= 1"
              @click="changePage(pagination.currentPage - 1)"
            >
{{ $t('common.previous') }}
            </button>
            <span class="page-info">
{{ $t('common.pageInfo', { current: pagination.currentPage, total: pagination.totalPages }) }}
            </span>
            <button 
              class="page-btn" 
              :disabled="pagination.currentPage >= pagination.totalPages"
              @click="changePage(pagination.currentPage + 1)"
            >
{{ $t('common.next') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { getSmsFlowRecords, exportSmsFlowRecords } from '@/api/sms'
import { getMailHistory } from '@/api/mail'
import { isAuthenticated } from '@/api/user'
import { useRouter } from 'vue-router'

export default {
  name: 'ReceiveRecordsView',
  setup() {
    const router = useRouter()
    const records = ref([])
    const loading = ref(false)
    const exporting = ref(false)
    const activeTab = ref('phone')

    const filters = reactive({
      channelCode: ''
    })
    
    const pagination = reactive({
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      total: 0
    })
    
    // 检查登录状态
    const checkAuth = () => {
      if (!isAuthenticated()) {
        ElMessage.warning(this.$t('messages.loginRequired'))
        router.push('/login')
        return false
      }
      return true
    }
    
    // 获取记录列表
    const fetchRecords = async () => {
      if (!checkAuth()) return
      
      try {
        loading.value = true
        const params = activeTab.value === 'phone'
          ? {
              page: pagination.currentPage,
              pageSize: pagination.pageSize,
              projectId: '',
              ...(filters.channelCode ? { code: filters.channelCode } : {})
            }
          : {
              pageNum: pagination.currentPage,
              pageSize: pagination.pageSize
            }

        const res = activeTab.value === 'phone'
          ? await getSmsFlowRecords(params)
          : await getMailHistory(params)
        if (res.success) {
          records.value = res.data.list || []
          pagination.total = res.data.total || 0
          pagination.totalPages = Math.ceil(pagination.total / pagination.pageSize)
        }
      } catch (error) {
        console.error(this.$t('console.fetchReceiveRecordsFailed'), error)
      } finally {
        loading.value = false
      }
    }
    
    // 应用筛选
    const applyFilters = () => {
      pagination.currentPage = 1
      fetchRecords()
    }
    
    // 重置筛选
    const resetFilters = () => {
      filters.channelCode = ''
      pagination.currentPage = 1
      fetchRecords()
    }

    const changeRecordType = type => {
      if (activeTab.value === type) return
      activeTab.value = type
      pagination.currentPage = 1
      pagination.total = 0
      pagination.totalPages = 1
      fetchRecords()
    }

    // 导出记录
    const handleExport = async () => {
      if (!checkAuth()) return

      try {
        exporting.value = true
        const params = {
          projectId: '',
          ...(filters.channelCode ? { code: filters.channelCode } : {})
        }

        const blob = await exportSmsFlowRecords(params)

        // 创建下载链接
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url

        // 生成文件名
        const now = new Date()
        const dateStr = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}`
        link.download = `数据记录_${dateStr}.xlsx`

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        ElMessage.success('导出成功')
      } catch (error) {
        console.error('导出失败', error)
        ElMessage.error(error.message || '导出失败，请稍后重试')
      } finally {
        exporting.value = false
      }
    }
    
    // 刷新记录
    const refreshRecords = () => {
      fetchRecords()
    }
    
    // 复制文本
    const copyText = async (text) => {
      try {
        await navigator.clipboard.writeText(text)
        ElMessage.success(this.$t('messages.copySuccess'))
      } catch (error) {
        console.error(this.$t('console.copyFailed'), error)
        ElMessage.error(this.$t('messages.copyFailed'))
      }
    }
    
    // 换页
    const changePage = (page) => {
      pagination.currentPage = page
      fetchRecords()
    }
    
    const hasValue = (value) => value !== undefined && value !== null && value !== ''
    const hasActivity = (record) => {
      const discountAmount = Number(record?.discountAmount)
      const hasPositiveDiscount = !Number.isNaN(discountAmount) && discountAmount > 0
      const hasDiscountPrice = hasValue(record?.discountUserMoney) && hasValue(record?.originalUserMoney) && String(record.discountUserMoney) !== String(record.originalUserMoney)
      return Boolean(record?.discountActivityId || hasPositiveDiscount || hasDiscountPrice)
    }
    const getActualAmount = (record) => hasValue(record?.userMoney) ? record.userMoney : (hasValue(record?.discountUserMoney) ? record.discountUserMoney : '--')
    const getOriginalAmount = (record) => hasValue(record?.originalUserMoney) ? record.originalUserMoney : getActualAmount(record)
    const getDiscountAmount = (record) => hasValue(record?.discountAmount) ? record.discountAmount : '--'
    const getActivityName = (record) => record?.discountActivityName || (record?.discountActivityId ? `#${record.discountActivityId}` : '--')

    // 格式化日期和时间
    const formatDateTime = (dateTime) => {
      if (!dateTime) return '--'
      return dateTime
    }
    
    // 截断文本
    const truncateText = (text, maxLength) => {
      if (!text) return ''
      return text.length > maxLength ? text.substr(0, maxLength) + '...' : text
    }
    
    onMounted(() => {
      fetchRecords()
    })
    
    return {
      records,
      loading,
      exporting,
      activeTab,
      filters,
      pagination,
      applyFilters,
      resetFilters,
      changeRecordType,
      refreshRecords,
      handleExport,
      copyText,
      changePage,
      formatDateTime,
      truncateText,
      hasActivity,
      getActualAmount,
      getOriginalAmount,
      getDiscountAmount,
      getActivityName
    }
  }
}
</script>

<style scoped>
.receive-records-page {
  padding: 40px 0;
  min-height: calc(100vh - var(--header-height) - var(--footer-height));
}

.page-header {
  text-align: center;
  margin-bottom: 40px;
}

.record-type-tabs {
  display: flex;
  width: fit-content;
  margin: 0 auto 24px;
  border-bottom: 1px solid var(--border-color);
}

.record-type-tab {
  min-width: 112px;
  padding: 10px 16px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
}

.record-type-tab:hover {
  color: var(--primary-color);
}

.record-type-tab.active {
  border-bottom-color: var(--primary-color);
  color: var(--primary-color);
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 12px;
  color: var(--text-primary);
}

.page-subtitle {
  font-size: 16px;
  color: var(--text-secondary);
}

.filters-section {
  margin-bottom: 30px;
}

.filters-content {
  display: flex;
  gap: 20px;
  align-items: end;
  padding: 20px;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 200px;
  flex: 1;
}

.filter-label {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
}

.filter-select, .filter-input {
  padding: 8px 12px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  font-size: 14px;
  transition: all 0.2s;
}

.filter-select:focus, .filter-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(68, 97, 242, 0.1);
}

.filter-actions {
  display: flex;
  gap: 12px;
  align-self: flex-end;
}

.records-section .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-color);
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
}

.header-actions {
  display: flex;
  gap: 12px;
}

.records-table {
  --records-grid-columns: 130px 90px 90px 90px 130px 140px 120px minmax(220px, 1fr) 170px;
  overflow-x: auto;
  width: 100%;
}

.mail-records-table {
  --records-grid-columns: 140px minmax(230px, 1.2fr) 160px 100px 130px 170px;
}

.table-header {
  display: grid;
  grid-template-columns: var(--records-grid-columns);
  column-gap: 12px;
  min-width: 1260px;
  box-sizing: border-box;
  background-color: var(--hover-color);
  padding: 16px 20px;
  font-weight: 600;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-color);
}

.table-row {
  display: grid;
  grid-template-columns: var(--records-grid-columns);
  column-gap: 12px;
  min-width: 1260px;
  box-sizing: border-box;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-color);
  transition: all 0.2s;
}

.table-row:hover {
  background-color: var(--hover-color);
}

.table-cell {
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
}

.table-header .table-cell {
  white-space: nowrap;
}

.channel-code {
  font-family: 'Courier New', monospace;
  font-weight: 500;
  color: var(--text-primary);
}

.phone-number {
  font-family: 'Courier New', monospace;
  font-weight: 500;
  color: var(--text-primary);
  cursor: pointer;
}

.phone-number:hover {
  color: var(--primary-color);
  text-decoration: underline;
}

.price {
  font-weight: 600;
  color: #10B981;
}

.original-price {
  color: #9CA3AF;
  font-size: 13px;
  font-weight: 500;
  text-decoration: line-through;
}

.price-muted {
  color: #9CA3AF;
}

.discount-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 3px 8px;
  background: linear-gradient(135deg, #DC2626 0%, #991B1B 100%);
  color: #FFF7ED;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.2);
  font-size: 12px;
  font-weight: 800;
}

.activity-name {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 999px;
  padding: 3px 8px;
  border: 1px solid rgba(245, 158, 11, 0.55);
  background: linear-gradient(135deg, #111827 0%, #000000 55%, #7F1D1D 100%);
  color: #FDE68A;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18), inset 0 0 0 1px rgba(255, 255, 255, 0.06);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.activity-name::before {
  content: '🔥';
  font-size: 10px;
}

.time-info {
  text-align: left;
}

.time-info .date {
  font-size: 14px;
  color: var(--text-primary);
}

.message-content {
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.4;
  word-break: break-all;
  cursor: pointer;
}

.message-content:hover {
  color: var(--primary-color);
}

.verification-code {
  display: flex;
  align-items: center;
  gap: 8px;
}

.code-value {
  font-family: 'Courier New', monospace;
  font-size: 14px;
  font-weight: 700;
  color: var(--primary-color);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: rgba(68, 97, 242, 0.1);
}

.copy-btn {
  background: none;
  border: none;
  color: var(--text-tertiary);
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;
}

.copy-btn:hover {
  color: var(--primary-color);
  background-color: rgba(68, 97, 242, 0.1);
}

.no-code {
  color: var(--text-tertiary);
}

.loading-state, .empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: var(--text-tertiary);
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--border-color);
  border-top: 4px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 20px;
  border-top: 1px solid var(--border-color);
}

.page-btn {
  padding: 8px 16px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  background-color: var(--card-background);
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  color: var(--text-secondary);
  font-size: 14px;
}

/* 平板适配 */
@media (max-width: 1024px) {
  .filters-content {
    flex-direction: column;
    align-items: stretch;
  }
  
  .filter-group {
    min-width: auto;
  }
  
  .filter-actions {
    align-self: stretch;
  }

  .page-title {
    font-size: 28px;
  }
}

/* 768px以下平板和大屏移动端适配 */
@media (max-width: 768px) {
  .receive-records-page {
    padding: 20px 0;
  }

  .page-header {
    margin-bottom: 30px;
  }

  .page-title {
    font-size: 24px;
    margin-bottom: 8px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .filters-section {
    margin-bottom: 20px;
  }

  .filters-content {
    padding: 16px;
    gap: 16px;
  }

  .filter-input {
    padding: 12px;
    font-size: 16px; /* 防止iOS缩放 */
  }

  .header-actions {
    flex-direction: column;
    gap: 8px;
  }
  
  /* 将表格转换为卡片式布局 */
  .records-table {
    display: block;
  }

  .table-header {
    display: none; /* 隐藏表头 */
  }
  
  .table-row {
    display: block;
    min-width: 0;
    margin-bottom: 16px;
    padding: 16px;
    background-color: var(--card-background);
    border: 1px solid var(--border-color);
    border-radius: var(--radius-md);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    position: relative;
  }

  .table-row:hover {
    background-color: var(--card-background);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .table-cell {
    display: flex;
    align-items: center;
    padding: 8px 0;
    border-bottom: none;
    justify-content: space-between;
  }

  .table-cell::before {
    content: attr(data-label);
    font-weight: 600;
    color: var(--text-secondary);
    min-width: 100px;
    flex-shrink: 0;
  }

  /* 为每个单元格添加标签 */
  .table-cell:nth-child(1)::before { content: '渠道代码'; }
  .table-cell:nth-child(2)::before { content: '实付金额'; }
  .table-cell:nth-child(3)::before { content: '原始金额'; }
  .table-cell:nth-child(4)::before { content: '优惠金额'; }
  .table-cell:nth-child(5)::before { content: '活动'; }
  .table-cell:nth-child(6)::before { content: '临时号码'; }
  .table-cell:nth-child(7)::before { content: '共享数据'; }
  .table-cell:nth-child(8)::before { content: '数据内容'; }
  .table-cell:nth-child(9)::before { content: '时间'; }

  .table-cell:last-child {
    border-bottom: none;
  }

  .verification-code {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .code-value {
    font-size: 16px;
    padding: 6px 12px;
  }

  .copy-btn {
    padding: 6px;
    align-self: flex-start;
  }

  .message-content {
    max-width: 200px;
    word-break: break-word;
  }
  
  .pagination {
    flex-direction: column;
    gap: 12px;
  }

  .page-btn {
    padding: 12px 20px;
    font-size: 16px;
    min-height: 44px; /* 符合触摸标准 */
  }
}

/* 480px以下移动端适配 */
@media (max-width: 480px) {
  .receive-records-page {
    padding: 16px 0;
  }

  .container {
    padding: 0 12px;
  }

  .page-title {
    font-size: 20px;
  }

  .page-subtitle {
    font-size: 13px;
  }

  .card {
    border-radius: var(--radius-sm);
    margin: 0 -4px;
  }

  .filters-content {
    padding: 12px;
  }

  .filter-label {
    font-size: 13px;
  }

  .filter-input {
    padding: 14px 12px;
    border-radius: var(--radius-md);
  }

  .filter-actions {
    gap: 8px;
  }

  .btn {
    padding: 12px 16px;
    font-size: 14px;
    border-radius: var(--radius-md);
    min-height: 44px;
  }

  .btn svg {
    width: 14px;
    height: 14px;
  }

  .records-section .card-header {
    padding: 16px;
  }

  .card-title {
    font-size: 16px;
  }

  .messages-list {
    padding: 12px;
  }

  .table-row {
    padding: 12px;
    margin-bottom: 12px;
  }

  .table-cell {
    padding: 6px 0;
    font-size: 14px;
  }

  .table-cell::before {
    font-size: 12px;
    min-width: 80px;
  }

  .channel-code, .phone-number {
    font-size: 13px;
  }

  .price {
    font-size: 16px;
    font-weight: 700;
  }

  .code-value {
    font-size: 14px;
    padding: 4px 8px;
  }

  .message-content {
    font-size: 13px;
    max-width: 150px;
  }

  .time-info .date {
    font-size: 12px;
  }

  .pagination {
    padding: 16px;
  }

  .page-info {
    font-size: 13px;
  }
}

/* 360px以下小屏移动端适配 */
@media (max-width: 360px) {
  .container {
    padding: 0 8px;
  }

  .page-title {
    font-size: 18px;
  }

  .filters-content {
    padding: 10px;
  }

  .filter-input {
    padding: 12px 10px;
  }

  .btn {
    padding: 10px 12px;
    font-size: 13px;
  }

  .card-title {
    font-size: 15px;
  }

  .table-row {
    padding: 10px;
  }

  .table-cell {
    padding: 5px 0;
    font-size: 13px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .table-cell::before {
    font-size: 11px;
    min-width: auto;
    margin-bottom: 2px;
  }

  .verification-code {
    width: 100%;
  }

  .code-value {
    font-size: 13px;
    padding: 3px 6px;
  }

  .copy-btn {
    padding: 4px;
  }

  .copy-btn svg {
    width: 12px;
    height: 12px;
  }

  .message-content {
    font-size: 12px;
    max-width: 100%;
    line-height: 1.3;
  }

  .loading-state, .empty-state {
    padding: 40px 20px;
  }

  .spinner {
    width: 32px;
    height: 32px;
  }
}
</style>
